function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.083 12.5c0 3.222-3.003 5.625-6.708 5.625V20C19.139 20 23 16.642 23 12.5 23 8.358 19.139 5 14.375 5h-5.75C3.862 5 0 8.358 0 12.5c0 3.433 2.653 6.327 6.273 7.218v-1.935c-2.545-.773-4.356-2.781-4.356-5.283 0-3.222 3.003-5.625 6.708-5.625h5.75c3.705 0 6.708 2.403 6.708 5.625z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.917 19.5c0-3.222 3.003-5.625 6.708-5.625V12C12.861 12 9 15.358 9 19.5s3.861 7.5 8.625 7.5h5.75C28.139 27 32 23.642 32 19.5c0-3.433-2.653-6.327-6.273-7.218v1.935c2.545.773 4.356 2.781 4.356 5.283 0 3.222-3.003 5.625-6.708 5.625h-5.75c-3.705 0-6.708-2.403-6.708-5.625z"
});

var SvgLink = function SvgLink(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "c733e3a7d8777054fe55aacf15efef1a.svg";
export { SvgLink as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/link.svg
// module id = null
// module chunks = 